import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { RackState } from 'libs/ui';
import { useVideoUrls, useRackState } from 'libs/hooks';
import withRackLogic from '../withRackLogic';
import { RackWrapper } from '../styledComponents';
import { RackVideos } from '../rack/rack-videos/rack-videos';
import ConfirmWithComment from './ConfirmWithComment';
import { StyledControlPanel, Buttons, OpenGateButton } from './goose.styled';

const GooseControl = (props) => {
  const { id, sendControlMsg, status } = props;
  const { t } = useTranslation();
  const mode = status?.mode;
  useRackState({ mode, sendControlMsg, id });

  const [showConfirm, setShowConfirm] = useState(false);
  const [working, setWorking] = useState(false);
  const [action, setAction] = useState(() => '');
  const { cams } = useVideoUrls({ sendControlMsg, streams: status?.streams, mode, id });

  const withCommentWhenOpen = window.dict['reasonofpass'] !== undefined;
  const rightControl = window.haveRight('mnemo.rack_control');
  const offline = mode === 'offline';
  let cl = '';
  let cl1 = offline ? 'offline' : '';
  let cl2 = offline ? 'offline1' : '';
  if (!cams) {
    cl += ' loading';
    cl1 += ' loading';
    cl2 += ' offline1';
  }
  const btncl = working ? 'working' : '';

  /**
   * action open gate
   * @param {*} type
   * @param {*} comment
   */
  const doOpenGate = (type, comment = undefined) => {
    if (working) {
      return;
    }
    setWorking(true);

    const out = {};
    if (comment) {
      out.comment = comment;
    }
    sendControlMsg(type, null, out);
    setTimeout(() => {
      setWorking(false);
    }, 500);
  };

  /**
   * open gate with confirm and comment
   * @param {*} type
   */
  const openWithConfirm = (type) => {
    if (!withCommentWhenOpen) {
      doOpenGate(type);
      return;
    }

    setAction((comment) => {
      doOpenGate(type, comment);
    });
    setShowConfirm(true);
  };

  /**
   * close confirm
   */
  const closeConfirm = () => {
    setShowConfirm(false);
  };

  /**
   * open gate
   */
  const openGate = () => {
    openWithConfirm('open_main');
  };

  return (
    <RackWrapper className={cl}>
      <RackVideos cams={cams} id={id} cl={cl2} />
      <StyledControlPanel className={cl1}>
        <Buttons>
          <OpenGateButton className={btncl} disabled={!rightControl} onClick={openGate}>
            {t('buttons.Открыть дверь')}
          </OpenGateButton>
        </Buttons>
        {showConfirm && <ConfirmWithComment close={closeConfirm} action={action} />}
      </StyledControlPanel>
      <RackState sendControlMsg={sendControlMsg} id={id} offline={offline} gooseMode />
    </RackWrapper>
  );
};

export default withRackLogic(GooseControl, { type: 'rack', reloadType: 'reboot controller' });
